import api from '@/shared/api/api';
import { PatientService } from '@/shared/api/protocol-ts/api/core/svc_patient_connectweb';
import {
  CreatePatientReq,
  CreatePatientResp,
  DeletePatientReq,
  DeletePatientResp,
  SetPatientClinicalCaseDescriptionReq,
  SetPatientClinicalCaseDescriptionResp,
  SetPatientExternalIDReq,
  SetPatientExternalIDResp,
  SetPatientGenderReq,
  SetPatientGenderResp,
  SetPatientPersonalDataReq,
  SetPatientPersonalDataResp,
  SetPatientStatusReq,
  SetPatientStatusResp,
} from '@/shared/api/protocol-ts/api/core/svc_patient_pb';
import { SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

type PatientRequests = keyof typeof PatientService.methods;

const generatePatientThunk = createThunkGenerator<PatientRequests>(
  SliceName.patient,
);

export const createPatient = generatePatientThunk<
  CreatePatientReq,
  CreatePatientResp
>('createPatient', (request) => {
  return api.patient.createPatient(request);
});

export const deletePatient = generatePatientThunk<
  DeletePatientReq,
  DeletePatientResp
>('deletePatient', api.patient.deletePatient);

export const setPatientPersonalData = generatePatientThunk<
  SetPatientPersonalDataReq,
  SetPatientPersonalDataResp
>('setPatientPersonalData', api.patient.setPatientPersonalData);

export const setPatientExternalID = generatePatientThunk<
  SetPatientExternalIDReq,
  SetPatientExternalIDResp
>('setPatientExternalID', api.patient.setPatientExternalID);

export const setPatientGender = generatePatientThunk<
  SetPatientGenderReq,
  SetPatientGenderResp
>('setPatientGender', api.patient.setPatientGender);

export const setPatientStatus = generatePatientThunk<
  SetPatientStatusReq,
  SetPatientStatusResp
>('setPatientStatus', api.patient.setPatientStatus);

export const setPatientClinicalCaseDescription = generatePatientThunk<
  SetPatientClinicalCaseDescriptionReq,
  SetPatientClinicalCaseDescriptionResp
>(
  'setPatientClinicalCaseDescription',
  api.patient.setPatientClinicalCaseDescription,
);
